import React from 'react';
import { Alert, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

/**
 * Trial state line. Shown while the site is in its free 30 days (or lapsed): days left, the
 * price, and the confirm button that keeps the site up after the trial.
 */
export default function TrialBanner({ website, onConfirm, busy }) {
  const { t } = useTranslation();
  if (!website || website.included) return null;
  if (website.status !== 'trial' && website.status !== 'unpublished') return null;
  if (!website.trial_ends_at) return null;
  const end = new Date(website.trial_ends_at);
  const daysLeft = Math.max(0, Math.ceil((end.getTime() - Date.now()) / 86400000));
  const confirmed = Boolean(website.trial_confirmed_at);
  const lapsed = website.status === 'unpublished' && daysLeft === 0;

  let text;
  if (confirmed) text = t('website.trial_confirmed', { date: end.toLocaleDateString('fi-FI') });
  else if (lapsed) text = t('website.trial_lapsed');
  else text = t('website.trial_days_left', { days: daysLeft, date: end.toLocaleDateString('fi-FI') });

  return (
    <Alert
      severity={confirmed ? 'success' : lapsed ? 'warning' : 'info'}
      sx={{ mb: 2 }}
      data-testid="website-trial-banner"
      action={!confirmed ? (
        <Button color="inherit" size="small" onClick={onConfirm} disabled={busy} data-testid="website-confirm">
          {t('website.confirm_addon')}
        </Button>
      ) : null}
    >
      {text}
    </Alert>
  );
}
